import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const ItemsContainer = styled.div`
  display: flex;
  flex-wrap: 1;
  flex-direction: column;
  row-gap: 28px;

  span {
    color: ${theme.color.designSystem.blackOpacity87};
    font-weight: ${theme.font.weight.bold};
  }
`;

export const NumberOfItems = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
`;

export const ModalDescription = styled.div`
  font-size: ${theme.font.size.small};
  line-height: 16px;
  margin-bottom: 24px;
`;

export const InlineLink = styled.a`
  cursor: pointer;
  color: ${theme.color.designSystem.purple70};
  font-weight: ${theme.font.weight.bold};

  &:hover {
    background-color: hsla(265, 100%, 47%, 0.04);
  }

  &:focused {
    background-color: hsla(265, 65%, 46%, 0.17);
  }

  &:active {
    background-color: hsla(265, 65%, 46%, 0.1);
  }
`;

export const CenterContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 100px;
  padding-right: 70px;
  padding-left: 70px;
  text-align: center;
`;

export const OneLineContent = styled(CenterContent)`
  column-gap: 4px;
  flex-direction: row;
`;
